import React, { Component, Fragment, createRef } from 'react';
import { secondsTohhmmss } from '../../../../helpers/time'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Props from './CartSummaryComponent';
import FormattedCurrency from '../../../../shared/FormattedCurrency';
import { getTotalSelectedProducts } from '../../product-picker/selectors/products';
import { getTotalSelectedItems } from '../../ticket-picker/selectors/selected-items';
import { isSeatedListing } from '../../../selectors/reserved-seating';
import { getEventDate, getXssFilter } from '../../../helpers/helpers';
import Translation from "../../../../shared/Translation";
import {deDuplicateDiscountCoupons} from "../../coupon/helpers/coupon";
import { getMainEvent, hasCoupons } from '../../../selectors/event';
import {getSeatsRange} from "../../../../helpers/seatsRange";
import classNames from 'classnames';
import {subTotal} from '../../../helpers/subTotal';
import { selectCartInsuranceFee } from '../../../selectors/reservation';
import { ReservationTimer } from './ReservationTimer';
import clsx from 'clsx';
import { isCurrentRouterState, getFeeDisplayOption } from '../../../selectors/ui';
import { getSelectedDeliveryOption } from '../../../selectors/delivery';
import { TranslationContext } from '../../../config/Translations';
import Button from '../../../../shared/Button';
import { TICKET_FEE_SEPARATE } from '../../../reducers/ui';
import { createPortal } from 'react-dom';
import InlineCouponModal from './InlineCouponModal';
import { selectSelectedPaymentPlan } from '../../../selectors/paymentPlans';
import { getConfigBooleanValue } from '@showclix-shared-util/configClient';

class CartSummary extends Component<Props> {
    constructor() {
      super();

      this.state = {
        isCartVisible: true,
        eventsCartOpened: {},
        isPromoCodeModalVisible: false
      }

      this.cartWrapRef = createRef();
      this.checkoutWrap = document.getElementById('checkout-overlay');

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.target.classList.contains("cart-summary") || this.props.onConfirmation) return;

          this.setState({
            isCartVisible: entry.isIntersecting
          })
        });
      })
    }

    componentDidMount() {
      if (this.cartWrapRef?.current) {
        this.intersectionObserver.observe(this.cartWrapRef.current);
      }
    }

    componentWillUnmount() {
      this.intersectionObserver.disconnect();
    }

    toggleEventCartSummary = (eventName) => {
      this.setState((prevState) => {
        const isOpen = prevState.eventsCartOpened[eventName];
        return {
          eventsCartOpened: {
            ...prevState.eventsCartOpened,
            [eventName]: !isOpen
          }
        };
      });
    }

    isEventCartSummaryCollapsed = (eventName) => {
      return !this.state.eventsCartOpened[eventName] || false;
    }

    getLocation = ( locationFromTicket = null ) => {
      if (this.props.uiConfig.hide_venue){
        return null;
      }

      let location = locationFromTicket || (this.props.venueName + ", " + this.props.venueAddress);
      if (this.props.uiConfig?.listings?.useEventLocation === false) {
        location = this.props.uiConfig.listings.location;
      }

      return location;
  };

    renderCurrency = (currency) => {
        if (this.props.isTicketPicker) {
            return null;
        }

        return (
            <FormattedCurrency>
                {currency}
            </FormattedCurrency>
        );
    }

    renderGroupedItems = groupedItems => {
        return (
            <Fragment>
                {Object.values(groupedItems).map((groupedItem, index) => {
                    let seatInfoArray = [];
                    if (Array.isArray(groupedItem?.groupedSeatInfos) && groupedItem.groupedSeatInfos.length) {
                        for (let seatInfo of groupedItem.groupedSeatInfos){
                            let startWithComma = false;
                            let _seat_info = '';
                            if (!seatInfo?.row && !seatInfo?.seat){
                                continue;
                            }

                            // eslint-disable-next-line no-extra-boolean-cast
                            if (!!seatInfo?.section){
                                _seat_info += 'Sec ' + seatInfo.section;
                                startWithComma = true;
                            }

                            const placeType = seatInfo?.isTableSeat ? 'Table' : 'Row';
                            _seat_info += `${startWithComma ? ', ' : ''}${placeType} ${seatInfo.row}`;

                            if (seatInfo?.isTableSeat || seatInfo?.row) {
                              startWithComma = true;
                            }
                            // eslint-disable-next-line no-extra-boolean-cast
                            if (!!seatInfo?.seats) {
                                _seat_info += (startWithComma? ', ':'') + 'Seat(s) ' + seatInfo.seats;
                            }

                            if (_seat_info){
                                seatInfoArray.push(_seat_info);
                            }
                        }
                    }

                    //Translation Interpolation
                    return (
                        <div className="cart-summary__item" key={index}>
                            <div>
                                <div className="cart-summary__label">
                                    <span className="cart-summary-label__quantity">
                                      {groupedItem.quantity}
                                      <span className="quantity-multiplier"> x</span>
                                    </span>
                                    <span className="cart-summary-label__name">
                                        {groupedItem.name}
                                        {seatInfoArray.map((_seat_info, subIndex) => (
                                            <Fragment key={subIndex} >
                                                <br />
                                                <span className="cart-summary-label__name">{_seat_info}</span>
                                            </Fragment>
                                        ))}
                                    </span>

                                    {!groupedItem.fee ? null : (
                                        <Fragment>
                                            {groupedItem.fee > 0 && (
                                                <div className="cart-summary__fee">
                                                    <FormattedCurrency>{groupedItem.faceValue}</FormattedCurrency> + <FormattedCurrency>{groupedItem.fee}</FormattedCurrency>
                                                    &nbsp;
                                                    <Translation>{this.props.feeVerbiage ? 'checkout__fees_label' : 'checkout__service_fee_label'}</Translation>
                                                </div>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                            <div className="cart-summary__value">
                                {this.renderCurrency(groupedItem.totalCost)}
                            </div>
                        </div>
                    )
                })}
            </Fragment>
        );
    }

    renderKioskCartSummaryItems = (target, idPropName, namePropName) => {
      const grouped = Object.values(
        target.reduce((acc, curr) => {
          if (!acc[curr[idPropName]]) {
            return {
              ...acc,
              [curr[idPropName]]: { ...curr, quantity: 1 }
            }
          }

          const item = acc[curr[idPropName]];

          return {
            ...acc,
            [curr[idPropName]]: {
              ...item,
              quantity: item.quantity + 1
            }
          }
        }, {})
      );

      return grouped.map((item) => (
        <div className="cart-summary__item" key={item[idPropName]}>
          <div className="cart-summary__label">{item.quantity} x {item[namePropName]}</div>
          <div className="cart-summary__value">
            {this.renderCurrency(Number(item?.cost?.amount) * item.quantity)}
          </div>
        </div>
      ));
    }

    renderProducts = (productSalesList) => {

        if (this.props.isKioskMode) {
            if (!Array.isArray(productSalesList) || productSalesList.length < 1) {
                return null;
            }

            return this.renderKioskCartSummaryItems(productSalesList, 'product_id', 'product_name');
        }

        if (!productSalesList) {
            return null;
        }

        let productsGrouped = {};
        for (let thisProduct of productSalesList) {
            const groupKey = `${thisProduct.product_id}_${+thisProduct?.cost?.amount}_${thisProduct?.buyer_fee?.amount}`;
            if (!productsGrouped[groupKey]) {
                let productName = 'Product';
                let product = this.props.products[thisProduct.product_id];
                if (product) {
                    productName = product.name;
                // eslint-disable-next-line no-extra-boolean-cast
                } else if (!!thisProduct.product_name) {
                    productName = thisProduct.product_name;
                }
                productsGrouped[groupKey] = {
                    name: productName,
                    faceValue: thisProduct.cost.amount,
                    fee: thisProduct.buyer_fee.amount,
                    quantity: 0,
                    totalCost: 0
                };
            }
            productsGrouped[groupKey].quantity++;
            productsGrouped[groupKey].totalCost += (thisProduct.cost.amount + thisProduct.buyer_fee.amount);
        }
        return this.renderGroupedItems(productsGrouped);
    }

    renderBundles = bundleSalesList => {
        if (this.props.isKioskMode) {
            if (!Array.isArray(bundleSalesList) || bundleSalesList.length < 1) {
                return null;
            }

            return this.renderKioskCartSummaryItems(bundleSalesList, 'bundle_id', 'name');
        }

        if (!bundleSalesList) {
            return null;
        }

        let bundlesGrouped = {};
        for (let thisBundleSale of bundleSalesList) {
            if (!bundlesGrouped[thisBundleSale.bundle_id]) {
                let bundle = this.props.bundles[thisBundleSale.bundle_id];
                bundlesGrouped[thisBundleSale.bundle_id] = {
                    name: bundle ? bundle.name : <Translation>{'checkout__bundle'}</Translation>,
                    faceValue: thisBundleSale.cost.amount,
                    fee: thisBundleSale.buyer_fee.amount,
                    quantity: 0,
                    totalCost: 0
                };
            }
            bundlesGrouped[thisBundleSale.bundle_id].quantity++;
            bundlesGrouped[thisBundleSale.bundle_id].totalCost += (thisBundleSale.cost.amount + thisBundleSale.buyer_fee.amount);
        }
        return this.renderGroupedItems(bundlesGrouped);
    }

    renderAdditionalFees = () => {
        if (this.props.additionalFees.length === 0) {
            return null;
        }

        return this.props.additionalFees.map((fee, i) => {
            return <div className="cart-summary__item" key={i}>
                <div className="cart-summary__label">{fee.name}</div>
                <div className="cart-summary__value">
                    {this.renderCurrency(fee.fee_details.amount)}
                </div>
            </div>
        });
    };

    renderServiceFee = () => {
        if (!this.props.isKioskMode) return null;
        return (
            <div className="cart-summary__item">
              <div className="cart-summary__label"><Translation>{"checkout__service_fees"}</Translation></div>
                <div className="cart-summary__value">
                    {this.renderCurrency(this.props.buyerServiceFee && this.props.buyerServiceFee.amount ? this.props.buyerServiceFee.amount : 0)}
                </div>
            </div>
        );
    }

    renderGST = () => {
        if (!this.props.gst) return null;
        return (
            <div className="cart-summary__item">
              <div className="cart-summary__label"><Translation>{"checkout__gst_included"}</Translation></div>
                <div className="cart-summary__value">
                    {this.props.gst}
                </div>
            </div>
        );
    }

    getCouponDiscounts = () => {
        let discountTypeIds = [2, 7];
        let discountCouponsOnly = this.props.coupon.couponData.filter(couponEntry => discountTypeIds.includes(couponEntry.coupon_type));
        //update type check here
        if (!this.props.hasAutoCoupons && (!discountCouponsOnly || discountCouponsOnly.length === 0)) {
            return null;
        }

        if (this.props.hasAutoCoupons && this.props.coupon.autoCouponAmount !== "") {
            var autoCouponLine =
                <div className="cart-summary__item discount__line" key="autoCoupon">
                    <div className="cart-summary__label"><Translation>{'checkout__auto_discount'}</Translation></div>
                    <div className="cart-summary__value">
                        ({this.renderCurrency(this.props.coupon.autoCouponAmount)})
                    </div>
                </div>;
        }

        let discountCouponLine = null;

        if (discountCouponsOnly.length) {
          const deDuppedDiscounts = deDuplicateDiscountCoupons(discountCouponsOnly);
          discountCouponLine = Object.values(deDuppedDiscounts).map((couponData, couponIndex) => (
            <div className="cart-summary__item discount__line" key={`${couponData.coupon_name}-${couponIndex}`}>
              <div className="cart-summary__label">{couponData.coupon_name}</div>
              <div className="cart-summary__value">({this.renderCurrency(couponData.amount)})</div>
            </div>
          ));
        }
        if (discountCouponsOnly.length && this.props.chargeDeliveryFee && this.props.deliveryFee) {
            let deliveryDiscount =  <div className="cart-summary__item discount__line" key= {"delivery_fee_discount"}>
                                        <div className="cart-summary__label">Delivery Fee Discount</div>
                                        <div className="cart-summary__value">({this.renderCurrency(this.props.deliveryFee)})</div>
                                    </div>
            discountCouponLine = [...discountCouponLine, deliveryDiscount];
        }

        return [
            (discountCouponLine) ? discountCouponLine : null,
            (autoCouponLine) ? autoCouponLine : null
        ];
    };

    renderTotal = () => {
        const { deliveryFee, chargeDeliveryFee, reservationDeliveryFee, cartInsuranceFee } = this.props;
        const totalCost = this.props.totalCost?.amount || 0;

        let total = this.props.totalCost
            ? subTotal({ deliveryFee, chargeDeliveryFee, totalCost, reservationDeliveryFee, cartInsuranceFee })
            : 0;
        if ((this.props.isKioskMode && this.props.isTicketPicker) || !this.hasFees()) {
            return null;
        }
        return (
            <div className="cart-summary__item cart-summary__total">
                <div className="cart-summary__label cart-summary__label--cart"><Translation>{'checkout__order_total'}</Translation></div>
                <div className="cart-summary__label cart-summary__label--confirmation"><Translation>{'checkout__total_payment'}</Translation></div>
                <div className="cart-summary__value">
                    {this.renderCurrency(total)}
                </div>
            </div>
        );
    };

    renderPaymentDue = () => {
        if (!this.props.selectedPlan) {
          return null;
        }

        const stub = this.props.onConfirmation ? 'checkout__amount_paid' : 'checkout__payment_due_today';

        const amount = this.props.onConfirmation ? this.props.amountPaid?.amount : this.props.selectedPlan.initialInstallmentAmount?.amount;

        return (
            <div className="cart-summary__item cart-summary__due-payment">
                <div className="cart-summary__label"><Translation>{stub}</Translation></div>
                <div className="cart-summary__value">
                    {this.renderCurrency(amount)}
                </div>
            </div>
        );
    }

    groupSeatInfos = seatInfos => {
        const groupedSeatInfos = [];
        const seatMap = new Map();

        seatInfos.forEach((seatInfo) => {
          if (seatInfo.seat) {
            const key = `${seatInfo.section}-${seatInfo.row}`;
            if (!seatMap.has(key)) {
              seatMap.set(key, { section: seatInfo.section, row: seatInfo.row, seat: [seatInfo.seat], isTableSeat: seatInfo.isTableSeat });
            } else {
              seatMap.get(key).seat.push(seatInfo.seat);
            }
            seatMap.get(key).seats = getSeatsRange(seatMap.get(key).seat);
          }
        });

        groupedSeatInfos.push(...seatMap.values());

        return groupedSeatInfos;
    }

    renderTickets = ticketList => {
        if (this.props.isKioskMode) {
           return this.renderKioskTickets(ticketList);
        }

        if (!ticketList) {
            return null;
        }

        let ticketsGrouped = {};
        for (let thisTicket of ticketList) {
            // group tickets by price level ID, cost, and listing upsell id
            const isPartOfTimeslotBuyout = !!thisTicket?.is_tsb;
            const useCostAmount = this.props.isSeated || isPartOfTimeslotBuyout;
            const useCostAmountOrPriceLevel = (this.props.appliedTaggableDiscountCode && this.props.isPyos) ? false : useCostAmount;
            const costValue = +(useCostAmountOrPriceLevel ? thisTicket?.cost?.amount : thisTicket?.price_level_cost?.amount) || 0; // to avoid NaN
            let ticketGroupKey;
            if (isPartOfTimeslotBuyout) {
              ticketGroupKey = `${thisTicket.price_level_id}_TSB`
            } else if (thisTicket.listing_upsell_id) {
              ticketGroupKey = `${thisTicket.price_level_id}_COST${costValue}_UPSELL${thisTicket.listing_upsell_id}`
            } else {
              ticketGroupKey = `${thisTicket.price_level_id}_COST${costValue}_PLNAME_${thisTicket?.price_level_name?.replace(/\s+/g, '_').toLowerCase()}`
            }

            if (!ticketsGrouped[ticketGroupKey]) {
                ticketsGrouped[ticketGroupKey] = {
                    name: thisTicket.price_level_name,
                    faceValue: thisTicket.price_level_cost.amount,
                    fee: isPartOfTimeslotBuyout ? 0 : thisTicket.buyer_fee.amount,
                    quantity: 0,
                    totalCost: 0,
                    seatInfos: [],
                };
            }

            ticketsGrouped[ticketGroupKey].quantity = isPartOfTimeslotBuyout
              ? 1
              : ticketsGrouped[ticketGroupKey].quantity + 1;

            if (isPartOfTimeslotBuyout) {
                ticketsGrouped[ticketGroupKey].fee += thisTicket.buyer_fee.amount;
            }

            ticketsGrouped[ticketGroupKey].totalCost += costValue + thisTicket.buyer_fee.amount;
            if(thisTicket?.seat_info !== undefined && thisTicket?.is_seated){
                ticketsGrouped[ticketGroupKey].seatInfos.push(thisTicket?.seat_info);
                ticketsGrouped[ticketGroupKey].groupedSeatInfos = this.groupSeatInfos(ticketsGrouped[ticketGroupKey].seatInfos);
            }
        }
        return this.renderGroupedItems(ticketsGrouped);
    }

    renderKioskTickets = ticketList => {
        let levels = {};

        for (let thisTicket of ticketList) {
            // price_level_cost will be present after carting the tickets
            // but not when previewing the cart at the ticket picker.
            const ticketCost = thisTicket?.price_level_cost?.amount !== undefined
                ? +thisTicket.price_level_cost.amount
                : +thisTicket.cost.amount;
            if (!levels[thisTicket.price_level_id]) {
                levels[thisTicket.price_level_id] = {
                    quantity: 1,
                    amount: ticketCost,
                }
            } else {
                levels[thisTicket.price_level_id].quantity = levels[thisTicket.price_level_id].quantity + 1;
                levels[thisTicket.price_level_id].amount = levels[thisTicket.price_level_id].amount + ticketCost;
            }
        }

        let renderedLevels = [];

        for (const levelId in levels) {
            renderedLevels.push(
                <div className="cart-summary__item" key={levelId}>
                    <div className="cart-summary__label">{levels[levelId].quantity} x {this.props.levels[levelId] ? this.props.levels[levelId].name : ''}</div>
                    <div className="cart-summary__value">
                        {this.renderCurrency(levels[levelId].amount)}
                    </div>
                </div>
            );
        }

        return renderedLevels;
    }

    hasFees = () => {
      const hasGST = this.props?.gst > 0;
      const hasAdditionalFees = this.props.additionalFees?.length > 0;
      const hasCouponDiscounts = this.getCouponDiscounts()?.length > 0;
      return hasGST || hasAdditionalFees || hasCouponDiscounts;
    }

    getItemsTitle = (tickets, products, bundles) => {
        const entries = {
          ticket: tickets.length,
          product: products.length,
          bundle: bundles.length,
        }

        const content = Object
          .entries(entries)
          .filter(([_, count]) => count > 0)
          .map(([type, count]) => (
            <Fragment key={type}>
              {count}{' '}
              <Translation>{entries[type] > 1 ? `checkout__${type}s` : `checkout__${type}`}</Translation>
            </Fragment>
          ));

        return content.reduce((acc, curr, index) => {
            if (index === content.length - 1 && index > 0) {
                return [...acc, " and ", curr];
            }
            return [...acc, index > 0 ? ', ' : '', curr];
        }, [" "]);
    }

    getItemsTotal = (tickets, products, bundles) => {
      const ticketsTotal = tickets.reduce((total, ticket) => {
        const isPartOfTimeslotBuyout = !!ticket?.is_tsb;
        const useCostAmount = this.props.isSeated || isPartOfTimeslotBuyout;
        const useCostAmountOrPriceLevel = (this.props.appliedTaggableDiscountCode && this.props.isPyos) ? false : useCostAmount;
        const costValue = +(useCostAmountOrPriceLevel ? ticket?.cost?.amount : ticket?.price_level_cost?.amount) || 0; // to avoid NaN

        return total + costValue + ticket.buyer_fee.amount;
      }, 0);
      const productsTotal = products.reduce((total, product) => total + product.cost.amount + product.buyer_fee.amount, 0);
      const bundlesTotal = bundles.reduce((total, bundle) => total + bundle.cost.amount + bundle.buyer_fee.amount, 0);
      return ticketsTotal + productsTotal + bundlesTotal;
    }

    groupItemsByEvent = () => {
        const eventGroups = {};
        this.props.tickets.forEach(ticket => {
            if (ticket.event_id) {
                if (eventGroups[ticket.event_id] === undefined) {
                    eventGroups[ticket.event_id] = {name: ticket.event_name, venue_name: ticket.venue_name, start: ticket.event_start, end: ticket.event_end, tickets: {}, products: {}, bundles: {}};
                }
                eventGroups[ticket.event_id].tickets[ticket.id] = ticket;
            }
        });
        this.props.productSales.forEach(product => {
            if (product.event_id) {
                if (eventGroups[product.event_id] === undefined) {
                    eventGroups[product.event_id] = {name: product.event_name, start: product.event_start, end: product.event_end, tickets: {}, products: {}, bundles: {}};
                }
                eventGroups[product.event_id].products[product.id] = product;
            }
        });
        this.props.bundleSales.forEach(bundle => {
            if (bundle.event_id) {
                if (eventGroups[bundle.event_id] === undefined) {
                    eventGroups[bundle.event_id] = {name: bundle.event_name, start: bundle.event_start, end: bundle.event_end, tickets: {}, products: {}, bundles: {}};
                }
                eventGroups[bundle.event_id].bundles[bundle.id] = bundle;
            }
        });
        return Object.values(eventGroups);
    }

    openPromoCodeModal = () => {
        this.setState({ isPromoCodeModalVisible: true });
    }

    closePromoCodeModal = () => {
        this.setState({ isPromoCodeModalVisible: false });
    }

    renderPromoCodeButton = () => {
        if (this.props.isKioskMode || !this.props.hasCoupons || this.props.onConfirmation) {
            return null;
        }

        return (
            <Fragment>
              <Button
                  className="button--link cart-summary__add-promo-code"
                  onClick={this.openPromoCodeModal}
              >
                  <Translation>{'checkout__add_promo_code'}</Translation>
              </Button>
              {createPortal(
                <InlineCouponModal open={this.state.isPromoCodeModalVisible} onClose={this.closePromoCodeModal} />,
                this.checkoutWrap
              )}
            </Fragment>
        );
    }

    renderAllFees = () => {
        return (
            <Fragment>
                {this.renderTicketsProductsAndBundles(this.props.tickets, this.props.productSales, this.props.bundleSales)}
                {this.renderAdditionalFeesAndTotal()}
            </Fragment>
        );
    }

    renderCollapsibleHeader = (eventGroup) => {
        const isFeeSeparate = this.props.feeDisplayOption === TICKET_FEE_SEPARATE;

        if (!isFeeSeparate) {
          return null;
        }

        const headerTotalAccent = this.isEventCartSummaryCollapsed(eventGroup.name) && !this.hasFees();

        return (
            <div className="cart-summary__group-collapsible-header">
                <Button
                    className="button--clear cart-summary__group-collapsible-header__control"
                    onClick={() => this.toggleEventCartSummary(eventGroup.name)}
                    aria-expanded={!this.isEventCartSummaryCollapsed(eventGroup.name)}
                    aria-controls={`cart-summary-event-${eventGroup.name}`}
                >
                    <i
                        className={clsx("icon", `icon-keyboard_arrow_${this.isEventCartSummaryCollapsed(eventGroup.name) ? 'down' : 'up'}`)}
                        aria-hidden="true"
                    />
                    <span className="cart-summary__group-collapsible-header__label">
                        {this.getItemsTitle(
                            Object.values(eventGroup.tickets),
                            Object.values(eventGroup.products),
                            Object.values(eventGroup.bundles)
                        )}
                    </span>
                </Button>
                <span className={clsx(
                    "cart-summary__group-collapsible-header__total",
                    {
                      "cart-summary__group-collapsible-header__total--accent": headerTotalAccent,
                    }
                )}>
                    {this.isEventCartSummaryCollapsed(eventGroup.name) && (
                        <FormattedCurrency>
                            {this.getItemsTotal(
                                Object.values(eventGroup.tickets),
                                Object.values(eventGroup.products),
                                Object.values(eventGroup.bundles)
                            )}
                        </FormattedCurrency>
                    )}
                </span>
            </div>
        );
    }

    renderFeesGroupedByEvent = () => {
        const eventGroups = this.groupItemsByEvent();
        const isFeeSeparate = this.props.feeDisplayOption === TICKET_FEE_SEPARATE;

        if (this.props.isDynamicListing) {
          const combinedEventGroup = {
            name: 'combined_events',
            tickets: eventGroups.reduce((acc, group) => ({...acc, ...group.tickets}), {}),
            products: eventGroups.reduce((acc, group) => ({...acc, ...group.products}), {}),
            bundles: eventGroups.reduce((acc, group) => ({...acc, ...group.bundles}), {}),
          }

          const isCollapsed = this.isEventCartSummaryCollapsed(combinedEventGroup.name);

          return (
            <Fragment>
              <div className="cart-summary__group">
                {this.renderCollapsibleHeader(combinedEventGroup)}
                <div
                  className={clsx(
                    "cart-summary__group-collapsible",
                    {"cart-summary__group-collapsible--collapsed": isFeeSeparate && isCollapsed}
                  )}
                  aria-hidden={isCollapsed}
                  role="region"
                  aria-labelledby={`cart-summary-event-${combinedEventGroup.name}`}
                  aria-describedby={`cart-summary-event-${combinedEventGroup.name}`}
                  id={`cart-summary-event-${combinedEventGroup.name}`}
                >
                  {eventGroups.map((eventGroup) => (
                    <Fragment key={eventGroup.name}>
                      <div className="cart-summary__event">
                          <div className="cart-summary__event-name">
                              {eventGroup.name}
                          </div>
                          <div className="cart-summary__event-date">
                              {getEventDate(eventGroup.start,eventGroup.end, this.props.locale, this.props.hide_event_time, this.props.hide_event_date_and_time)}
                          </div>
                          <div className="cart-summary__venue-name">
                              {this.getLocation()}
                          </div>
                      </div>
                      {this.renderTicketsProductsAndBundles(Object.values(eventGroup.tickets), Object.values(eventGroup.products), Object.values(eventGroup.bundles))}
                    </Fragment>
                  ))}
                </div>
              </div>
              {this.renderPromoCodeButton()}
              {this.renderAdditionalFeesAndTotal()}
            </Fragment>
          )
        }

        return (
            <Fragment>
                {eventGroups.length > 1 && eventGroups.map((eventGroup, index) => {
                    return (
                        <div className="cart-summary__group" key={index}>
                            {this.renderCollapsibleHeader(eventGroup)}
                            <div
                              className={clsx(
                                "cart-summary__group-collapsible",
                                {"cart-summary__group-collapsible--collapsed": isFeeSeparate && this.isEventCartSummaryCollapsed(eventGroup.name)}
                              )}
                              aria-hidden={this.isEventCartSummaryCollapsed(eventGroup.name)}
                              role="region"
                              aria-labelledby={`cart-summary-event-${eventGroup.name}`}
                              aria-describedby={`cart-summary-event-${eventGroup.name}`}
                              id={`cart-summary-event-${eventGroup.name}`}
                            >
                              <div className="cart-summary__event">
                                  <div className="cart-summary__event-name">
                                      {eventGroup.name}
                                  </div>
                                  <div className="cart-summary__event-date">
                                      {getEventDate(eventGroup.start,eventGroup.end, this.props.locale, this.props.hide_event_time, this.props.hide_event_date_and_time)}
                                  </div>
                                  <div className="cart-summary__venue-name">
                                    {this.getLocation(eventGroup.venue_name)}
                                  </div>
                              </div>
                              {this.renderTicketsProductsAndBundles(Object.values(eventGroup.tickets), Object.values(eventGroup.products), Object.values(eventGroup.bundles))}
                            </div>
                        </div>
                    );
                })}
                {
                    eventGroups.length == 1 &&
                    <div className="cart-summary__group">
                        {this.renderCollapsibleHeader(eventGroups[0])}
                        <div
                          className={clsx(
                            "cart-summary__group-collapsible",
                            {"cart-summary__group-collapsible--collapsed": isFeeSeparate && this.isEventCartSummaryCollapsed(eventGroups[0].name)}
                          )}
                          aria-hidden={this.isEventCartSummaryCollapsed(eventGroups[0].name)}
                          role="region"
                          aria-labelledby={`cart-summary-event-${eventGroups[0].name}`}
                          aria-describedby={`cart-summary-event-${eventGroups[0].name}`}
                          id={`cart-summary-event-${eventGroups[0].name}`}
                        >
                          <div className="cart-summary__event">
                              <div className="cart-summary__event-name">
                                  {eventGroups[0].name}
                              </div>
                              <div className="cart-summary__event-date">
                                  {getEventDate(eventGroups[0].start, eventGroups[0].end, this.props.locale, this.props.hide_event_time, this.props.hide_event_date_and_time)}
                              </div>
                              {!!this.props.seriesChildAdditionalInfo && (
                                <div className="cart-summary__additional_info">
                                  {this.props.seriesChildAdditionalInfo}
                                </div>
                              )}
                              <div className="cart-summary__venue-name">
                                  {this.getLocation()}
                              </div>
                          </div>
                          {this.renderTicketsProductsAndBundles(Object.values(eventGroups[0].tickets), Object.values(eventGroups[0].products), Object.values(eventGroups[0].bundles))}
                        </div>
                    </div>
                }
                {this.renderPromoCodeButton()}
                {this.renderAdditionalFeesAndTotal()}
            </Fragment>
        )
    }

    renderTicketsProductsAndBundles = (tickets, products, bundles) => {
        return (
            <div className="cart-summary__group">
                {this.renderTickets(tickets)}
                {this.renderProducts(products)}
                {this.renderBundles(bundles)}
            </div>
        );
    }

    renderLoyaltyRewards = () => {
        const { rewardAmount, rewardProviderName, isKioskMode } = this.props;
        if (isKioskMode || !rewardAmount || rewardAmount <= 0 || !rewardProviderName) {
            return null;
        }
        return (
            <div className="cart-summary__item">
                <div className="cart-summary__label">
                  {rewardProviderName === 'FanCash' ? (
                    <span className="cart-summary__fancash-label">{rewardProviderName}</span>
                  ) : rewardProviderName}
                  {' '}
                  <Translation>{'checkout__earned'}</Translation>
                </div>
                <div className="cart-summary__value">
                    {this.renderCurrency(rewardAmount)}
                </div>
            </div>
        );
    }

    renderAdditionalFeesAndTotal = () => {
        return (
            <Fragment>
                {!this.props.isTicketPicker && this.renderServiceFee()}
                {!this.props.isTicketPicker && this.renderAdditionalFees()}
                {!this.props.isTicketPicker && this.getCouponDiscounts()}
                {!this.props.isTicketPicker && this.renderGST()}
                {!this.props.isTicketPicker && this.renderTotal()}
                {!this.props.isTicketPicker && this.renderLoyaltyRewards()}
                {!this.props.isTicketPicker && getConfigBooleanValue('paymentPlans', false) && this.renderPaymentDue()}
            </Fragment>
        )
    }

    getDeliveryMethodName = (t) => {
      return this.props.deliveryMethodName;
    }

    render() {
        if (this.props.isKioskMode) {

            // if ticketpicker and nothing carted show message, otherwise show fees
            let feeDisplay = (this.props.isTicketPicker && this.props.bundleCount === 0 && this.props.selectedProducts === 0 && this.props.selectedItems === 0)
                ? <span className="cart-summary__empty-text"><Translation>{'checkout__cart_add_tickets'}</Translation></span>
                : this.renderAllFees();

            // if not ticket picker and items exist for multiple events, group the fees by event
            if (!this.props.isTicketPicker) {
                const eventGroups = this.groupItemsByEvent();
                if (eventGroups.length > 1) {
                    feeDisplay = this.renderFeesGroupedByEvent();
                }
            }

            return (
                <div className="kiosk-payment__cart-summary">
                    <div className="cart-summary__title"><Translation>{'checkout__order_summary'}</Translation></div>
                    <div className="cart-summary">
                        {feeDisplay}
                    </div>
                </div>
            );
        }

        const { deliveryFee, chargeDeliveryFee, reservationDeliveryFee, cartInsuranceFee } = this.props;
        const totalCost = this.props.totalCost?.amount || 0;

        const paymentNote = getXssFilter().process(this.props.paymentNote);

        return (
            <>
                <div className={classNames("sticky-cart", "hide-on-medium-screen", {"sticky-cart--hidden": this.state.isCartVisible})}>
                    <div className="sticky-cart__info">
                        <div className="cart-summary__icon">
                            <i className="icon-shopping_cart" aria-hidden="true">
                              <span className="sr-only">
                                Shopping cart
                              </span>
                            </i>
                            <span className="cart__items-count">{this.props.itemsCount}</span>
                        </div>
                        <p><Translation>{"checkout__cart"}</Translation></p>
                        <div className="cart-summary__total">
                            <FormattedCurrency>
                                {this.props.totalCost
                                    ? subTotal({
                                        deliveryFee,
                                        chargeDeliveryFee,
                                        reservationDeliveryFee,
                                        totalCost,
                                        cartInsuranceFee,
                                      })
                                    : 0
                                }
                            </FormattedCurrency>
                        </div>
                    </div>
                    <ReservationTimer time={this.props.time} showTimeOnly />
                </div>
                <div ref={this.cartWrapRef} className={clsx(
                  "cart-summary",
                  "card",
                  !this.props.onConfirmation && "cart-summary--lma"
                )}>
                    <div className="cart-summary__header">
                        <div className="cart-summary__icon">
                            <i className="icon-shopping_cart" aria-hidden="true">
                              <span className="sr-only">
                                Shopping cart
                              </span>
                            </i>
                        </div>
                        <div className="cart-summary__name" role='heading' aria-level='2'><Translation>{'checkout__cart_summary'}</Translation></div>
                        {this.props.editLink && (
                          <button
                            className="button--clear cart-summary__action-button"
                            onClick={this.props.editLink ? this.props.onEdit : () => { }}
                            role="link"
                            data-href="#cart"
                          >
                            <i className="icon-mode_edit" aria-hidden="true"></i> <Translation>{'checkout__edit'}</Translation> <span className="sr-only"><Translation>{'checkout__cart'}</Translation></span>
                          </button>
                        )}
                    </div>
                    <div className="cart-summary__body">
                        <div className="cart-summary__content">
                            <ReservationTimer time={this.props.time} />
                            {this.renderFeesGroupedByEvent()}
                            <div className="confirmation-info">
                              <p>
                                <Translation interpolation={{ id: this.props.confirmationNumber }}>
                                  {'checkout__conf_id'}
                                </Translation>
                              </p>
                              <p>
                                <TranslationContext.Consumer>
                                  {({ t }) => (
                                    <Translation interpolation={{ method: this.getDeliveryMethodName(t) }}>
                                      {'checkout__delivery_method_is'}
                                    </Translation>
                                  )}
                                </TranslationContext.Consumer>
                              </p>
                              <div className="confirmation-info__details">
                                {!!this.props.gst && !this.props.hideTaxInvoice && (
                                  <p className="tax-invoice">
                                    <Translation>
                                      {'checkout__tax_invoice'}
                                    </Translation>
                                  </p>
                                )}
                                {this.props.abn && (
                                  <p>
                                    <Translation interpolation={{ abn: this.props.abn, tag_start: '<bold>', tag_end: '</bold>' }}>
                                      {this.props.receiptLocale === 'en_NZ' ? 'checkout__nzbn_number' : 'checkout__abn_number'}
                                    </Translation>
                                  </p>
                                )}
                                {this.props.paymentNote && (
                                  <p dangerouslySetInnerHTML={{ __html: paymentNote }} />
                                )}
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state, props) => {
    const venue = state.venue.venues ? Object.values(state.venue.venues)[0] : null;
    const selectedDeliveryOption = getSelectedDeliveryOption(state);
    const deliveryMethodName = state.confirmation?.deliveryMethodName
      || selectedDeliveryOption?.name
      || '';
    const confirmationNumber = state.confirmation?.confirmationNumber
      || state.reservation?.confirmation_number
      || '';

    return {
        reservationDeliveryFee: state.reservation?.total_delivery_fees?.amount,
        deliveryFee: state.delivery?.price?.amount,
        chargeDeliveryFee: state.reservation?.noDeliveryFee,
        time: secondsTohhmmss(state.reservation.time_remaining),
        selectedProducts: getTotalSelectedProducts(state),
        selectedItems: getTotalSelectedItems(state),
        seriesChildAdditionalInfo: state.eventSeries.seriesChildAdditionalInfo,
        isSeated: isSeatedListing(state),
        hide_event_time: state.ui.uiConfig.hide_event_time,
        hide_event_date_and_time: getHideEventOption(state, props.hideEventDateTime, isCurrentRouterState('confirmation')(state)),
        totalCost: state.reservation.total_cost,
        itemsCount: state.reservation.items_count,
        feeVerbiage: getMainEvent(state)?.event?.fee_verbiage,
        appliedTaggableDiscountCode: state?.couponTag?.appliedTaggableDiscountCode,
        cartInsuranceFee: selectCartInsuranceFee(state),
        venueName: venue ? venue.name : "",
        venueAddress: venue ? venue.address.city + ', ' + venue.address.region : "",
        uiConfig: state.ui.uiConfig,
        deliveryOptionId: state.reservation.selected_delivery_option,
        deliveryMethodName,
        confirmationNumber,
        abn: state.confirmation.abn,
        gst: state.confirmation.gst,
        hideTaxInvoice: state.confirmation.hideTaxInvoice,
        paymentNote: state.confirmation.paymentNote,
        receiptLocale: state.confirmation.receiptLocale,
        onConfirmation: isCurrentRouterState('confirmation')(state),
        feeDisplayOption: getFeeDisplayOption(state),
        hasCoupons: hasCoupons(state),
        selectedPlan: getConfigBooleanValue('paymentPlans', false) ? selectSelectedPaymentPlan(state) : null,
        amountPaid: state.reservation.amount_paid,
        rewardAmount: state.reservation.rewardAmount || 0,
        rewardProviderName: state.reservation.rewardProviderName || null,
    };
}

const getHideEventOption = (state, hideEventDateTime, confirmation) => {
    if (state.ui?.uiConfig?.hide_event_date_and_time ||
        hideEventDateTime ||
        (confirmation && state.ui?.uiConfig?.checkout?.confirmation?.hideEventDateTime)
        ) {
        return true;
    }
    return false;
}

CartSummary.propTypes = {
    onEdit: PropTypes.func.isRequired,
    ticketTotal: PropTypes.object,
    productCount: PropTypes.number,
    productTotal: PropTypes.object,
    bundleCount: PropTypes.number,
    bundleTotal: PropTypes.object,
    buyerServiceFee: PropTypes.object,
    totalCost: PropTypes.object,
    additionalFees: PropTypes.arrayOf(PropTypes.object),
    discount: PropTypes.object,
    coupon: PropTypes.object,
    currencySymbol: PropTypes.string,
    hasAutoCoupons: PropTypes.bool,
    editLink: PropTypes.bool,
    isPyos: PropTypes.bool,
    isSeated: PropTypes.bool,
    onEditSeatSelection: PropTypes.func,
    hide_event_time: PropTypes.bool,
    hide_event_date_and_time: PropTypes.bool,
    hideEventDateTime: PropTypes.bool,
    rewardAmount: PropTypes.number,
    rewardProviderName: PropTypes.string,
  }

CartSummary.defaultProps = {
    editLink: true,
    hideEventDateTime: false,
}

export default connect(mapStateToProps)(CartSummary)
